export default {
    getWeather: (state) => state.weatherEntries
  }